import styles from './Addreses.module.scss'

const Addresses = ({ billingAddress, invoiceAddress }) => (
  <div className={styles.addresses}>
    <Address name="Billing Address" address={billingAddress} />
    <Address name="Invoice Address (hotel location)" address={invoiceAddress} />
  </div>
)

const Address = ({ name, address }) => (
  <div className={styles.address}>
    <div className={styles.title}>{name}</div>
    <div className={styles.value}>
      {address || <span className={styles.missing}>Missing address</span>}
    </div>
  </div>
)

export default Addresses
